<template>
  <el-dropdown
      v-bind="$attrs"
      v-on="$listeners"
      @command="handleCommand"
      class="gj-dropdown">
    <slot></slot>
    <el-dropdown-menu slot="dropdown">
      <slot name="dropdown"></slot>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import {isMeaningful} from "../../utils/common";

  export default {
    name: "gj-dropdown",
    methods: {
      handleCommand(command) {
        if (isMeaningful(this.$listeners.command)) {
          this.$emit('command', command);
        } else if (command instanceof Function) {
          command();
        }
      }
    }
  }
</script>

<style scoped>
  .gj-dropdown {
    cursor: pointer;
  }
</style>
